import { createLazyComponent, LazyModule, type LazyComponent } from "owa-bundling";
import { isCalendarSchedulingDialogOpen } from "owa-calendar-scheduling-dialog-store";
import { GovernPriority } from "owa-client-types/lib/GovernPriority";
import type * as lazyIndex from "./lazyIndex";

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(() => import(/* webpackChunkName: "CalendarSchedulingDialog" */ "./lazyIndex"), { name: "CalendarSchedulingDialog", govern: GovernPriority.Calendar });

export const CalendarSchedulingDialog: LazyComponent<{}, unknown, void> = createLazyComponent(lazyModule, m => m.CalendarSchedulingDialog, undefined, undefined, {
    onlyImportIf: isCalendarSchedulingDialogOpen,
});
